import { InboxOutlined } from "@ant-design/icons";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import CustomSelect from "@components/global/CustomSelect/CustomSelect";
import Loader from "@components/global/Loader/Loader";
import Button from "@components/global/new/Button/Button";
import Title from "@components/global/new/Title/Title";
import { MODALS_ENUM } from "@constants/Modals";
import { Upload } from "antd";
import { useIntl } from "react-intl";
import CustomSearch from "../../CustomSearch/CustomSearch";
import { ISparePartType } from "../../SpareParts.http";
import useAddSparePartsModalControl, { AddSparePartOnSuccess } from "./AddSpareParts.control";
import './AddSpareParts.modal.scss';

const { Dragger } = Upload;

interface AddSparePartsModalProps extends CommonModalPropsI { //PropsWithChildren<InjectedProps> {
  types: ISparePartType[];
  onSuccess: AddSparePartOnSuccess;
}

function AddSparePartsModal({
  types,
  onSuccess,
  handleClose,
}: AddSparePartsModalProps): JSX.Element {

  const { formatMessage } = useIntl();
  const control = useAddSparePartsModalControl(types, onSuccess, handleClose);

  return (
    <div className="modal__add-spareparts">
      <Title>{formatMessage({ id: "modal.add_spareparts.title" })}</Title>
      <form className="content" onSubmit={control.submit}>
        <div className="form-field">
          <label>Sparepart Type</label>
          <CustomSelect
            className="spareparts-types"
            options={control.options}
            onChange={ item => {
              const type = types.find(x => x.Id === item);
              if (type)control.setSelectedSparePartType(type);
            }}
          />
        </div>
        <div className="form-field">
          <label>Miner</label>
          <div className="search-container">
            <CustomSearch 
              isDisabled={control.isLoading}
              onChange={control.findFirst} 
            />
            <div className="search-container__loader">
              {control.isLoading && <Loader size={32} />}
            </div>
          </div>
          <div className="images__container">
            <Dragger
              accept='.jpg,.jpeg,.png,.webp,.gif'
              //action={"https://www.mocky.io/v2/5cc8019d300000980a055e76"}
              onRemove={control.draggerOnRemove}
              customRequest={control.draggerCustomRequest}
              onPreview={control.draggerOnPreview}
              fileList={control.images}
              maxCount={5}
              showUploadList={false}
              name='File'
            >
              <p className='ant-upload-drag-icon'>
               <InboxOutlined rev={undefined} />
              </p>
              <p>
                {formatMessage({ id: "modal.upload_photo.drop_text" })}
              </p>
              <p>jpg, jpeg, png, webp, gif</p>
            </Dragger>
          </div>
        </div>
        <div className="modal__add-spareaprts__footer">
          <Button type='submit'>
            {formatMessage({ id: "common.save" })}
          </Button>
        </div>
      </form>
      {/* 
				<div className="add_photo">
					<Image src={control.imageUrl} />
					<label htmlFor='upload-photo' className="photo">
						<Icon src={photo} />
						<div className="upload">
							<span>
								{formatMessage({ id: "modal.edit_account.app_photo" })}
							</span>
							<input
								type='file'
								onChange={(e) =>
									e.target.files && control.getImageUrl(e.target.files[0])
								}
								id='upload-photo'
								accept='image/jpeg,image/png,image/gif,image/jpg,image/webp'
							/>
						</div>
					</label>
				</div>

				<Field
					id='name'
					name={formatMessage({ id: "modal.add_spareparts.name" })}
					placeholder='Name'
					type='text'
					defaultValue={"Name"}
				/>

				<Button type='submit'>
					{formatMessage({ id: "common.save" })}
				</Button>
			</form>*/}
    </div>
  );
}


export default WithModal(MODALS_ENUM.ADD_SPAREPARTS, AddSparePartsModal);